import styled from 'styled-components'

import { helpers } from 'styles'

import { Row as DefaultRow } from 'components/Lists'

export const Row = styled(DefaultRow)`
	padding: ${helpers.spacing.small} ${helpers.spacing.large};

	&:last-child {
		padding-bottom: ${helpers.spacing.large};
	}
`
